/**
 * Durable Self-Scan checkout bind for phone-first remounts (G1 / AC-11).
 * When URL is stripped to `?sessionId=` only, basketPublicId still signals
 * Self-Scan handoff until GET session `collectLockedAt` hydrates.
 */

const STORAGE_PREFIX = 'customer:selfScan:checkoutBasket:';

function storageKey(tenantCode: string, sessionId: string): string {
  return `${STORAGE_PREFIX}${tenantCode}:${sessionId}`;
}

export function persistSelfScanCheckoutBasketPublicId(
  tenantCode: string,
  sessionId: string,
  basketPublicId: string,
): void {
  const sid = sessionId.trim();
  const basket = basketPublicId.trim();
  if (typeof window === 'undefined' || sid.length === 0 || basket.length === 0) {
    return;
  }
  try {
    window.sessionStorage.setItem(storageKey(tenantCode, sid), basket);
  } catch {
    // private mode / quota — GET collectLockedAt remains durable SoT
  }
}

export function readPersistedSelfScanCheckoutBasketPublicId(
  tenantCode: string,
  sessionId: string | null | undefined,
): string | null {
  const sid = sessionId?.trim() ?? '';
  if (typeof window === 'undefined' || sid.length === 0) {
    return null;
  }
  try {
    const raw = window.sessionStorage.getItem(storageKey(tenantCode, sid))?.trim() ?? '';
    return raw.length > 0 ? raw : null;
  } catch {
    return null;
  }
}

export function clearPersistedSelfScanCheckoutBasketPublicId(
  tenantCode: string,
  sessionId: string,
): void {
  const sid = sessionId.trim();
  if (typeof window === 'undefined' || sid.length === 0) {
    return;
  }
  try {
    window.sessionStorage.removeItem(storageKey(tenantCode, sid));
  } catch {
    // ignore
  }
}
